/**
 * @generated SignedSource<<a04a95b1569685cdae1bc4e352233ca8>>
 * @relayHash 7b9538c098ce550736bc97a0675115d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f70b5b338cd1e7e3264c63bae22c03f27f6f1afb037c5e24d62617162fdf9031

import type { ConcreteRequest } from 'relay-runtime';
export type ConvoAiErrorMessageTemplate = "A2A_ERROR" | "ACCEPTABLE_USE_VIOLATIONS" | "ERROR" | "PRE_EXECUTION_ERROR" | "%future added value";
export type ConvoAiMessageAuthorRole = "AGENT" | "ASSISTANT" | "HUMAN" | "%future added value";
export type useCommentAgentSessionStatusSubscription$variables = {
  cloudId: string;
  conversationId: string;
};
export type useCommentAgentSessionStatusSubscription$data = {
  readonly convoai_onAgentSessionUpdate: {
    readonly __typename: "ConvoAiConversationMessage";
    readonly actions: ReadonlyArray<{
      readonly key: string;
    } | null> | null;
    readonly agentSessionState: string | null;
    readonly role: ConvoAiMessageAuthorRole;
  } | {
    readonly __typename: "ConvoAiErrorMessage";
    readonly errorMessageTemplate: ConvoAiErrorMessageTemplate;
  } | {
    readonly __typename: "ConvoAiTraceMessage";
    readonly messageTemplate: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useCommentAgentSessionStatusSubscription = {
  response: useCommentAgentSessionStatusSubscription$data;
  variables: useCommentAgentSessionStatusSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
      }
    ],
    "kind": "LinkedField",
    "name": "convoai_onAgentSessionUpdate",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "messageTemplate"
          }
        ],
        "type": "ConvoAiTraceMessage"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "role"
          },
          {
            "kind": "ScalarField",
            "name": "agentSessionState"
          },
          {
            "concreteType": "ConvoAiAgentAction",
            "kind": "LinkedField",
            "name": "actions",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ],
        "type": "ConvoAiConversationMessage"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": "errorMessageTemplate",
            "kind": "ScalarField",
            "name": "messageTemplate"
          }
        ],
        "type": "ConvoAiErrorMessage"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCommentAgentSessionStatusSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCommentAgentSessionStatusSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7b9538c098ce550736bc97a0675115d4",
    "id": "f70b5b338cd1e7e3264c63bae22c03f27f6f1afb037c5e24d62617162fdf9031",
    "metadata": {},
    "name": "useCommentAgentSessionStatusSubscription",
    "operationKind": "subscription",
    "text": "subscription useCommentAgentSessionStatusSubscription($cloudId:ID!,$conversationId:ID!){convoai_onAgentSessionUpdate(cloudId:$cloudId,conversationId:$conversationId)@optIn(to:\"ConvoAiAgentSessionUpdate\"){__typename,...on ConvoAiTraceMessage{messageTemplate},...on ConvoAiConversationMessage{role,agentSessionState,actions{key}},...on ConvoAiErrorMessage{errorMessageTemplate:messageTemplate}}}"
  }
};
})();

(node as any).hash = "5269fa0e76b35c60b147b10f051b8478";

export default node;
